import { render, staticRenderFns } from "./StaticAutocomplete.vue?vue&type=template&id=21856365&scoped=true"
import script from "./StaticAutocomplete.vue?vue&type=script&lang=js"
export * from "./StaticAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21856365",
  null
  
)

export default component.exports